// LILAPE Jetton contract on TON mainnet
export const LILAPE_JETTON_ADDRESS = 'EQBX0-QIb1AhK-yGEKLVTpROPOy2wrp7YAqP44KK1kQgy3Fd';
export const LILAPE_DECIMALS = 9;
export const LILAPE_SYMBOL = 'LILAPE';
export const PRIZE_POOL_ADDRESS = 'UQCK0IC6VJt-nXPr8LSuMS-Y1U6EUH3b2A7CThcANRL_qXNG';
